import {createFeatureSelector, createSelector} from '@ngrx/store';

export interface ProductConfigurationState {
  success: boolean;
  processesCount: number;
}

const productConfiguratorFeatureKey = 'productConfigurator';

const selectStateSlice = createFeatureSelector<any>(productConfiguratorFeatureKey);

const selectFirstProductConfiguration = createSelector(selectStateSlice, (state) => {
  const firstConfiguration: any = Object.values(state.configurations.entities)[0];
  return {
    success: firstConfiguration?.success,
    processesCount: firstConfiguration?.processesCount,
  } as ProductConfigurationState;
});

export const fromProductConfigurator = {
  selectFirstProductConfiguration,
};
